module.exports = __webpack_public_path__ + "img/demoff2.jpg";